var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.prefixCls },
    [
      _c("i-input", {
        attrs: { size: "small", icon: _vm.icon, placeholder: _vm.placeholder },
        on: { "on-click": _vm.handleClick },
        model: {
          value: _vm.currentQuery,
          callback: function($$v) {
            _vm.currentQuery = $$v
          },
          expression: "currentQuery"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b1cef8bc", { render: render, staticRenderFns: staticRenderFns })
  }
}